import {useUserStore} from "@/stores/UserStore";

export default function authHeader() {
    const userStore = useUserStore()

    // let user = JSON.parse(localStorage.getItem('user'));
    // let user = userStore.user;

    // console.log("[authHeader] User Data = ", user);
    // console.log("[authHeader] userStore.accessToken = ", userStore.accessToken);
    // console.log("[authHeader] userStore.username = ", userStore.username);
    // console.log("[authHeader] userStore.userId = ", userStore.userId);
    // console.log("[authHeader] userStore.companyId = ", userStore.companyId);

    // if (user && user.accessToken) {
    //     return {Authorization: 'Bearer ' + user.accessToken};
    // } else {
    //     return {};
    // }

    if (userStore.accessToken) {
        return {Authorization: 'Bearer ' + userStore.accessToken};
    } else {
        return {};
    }

}
